if(typeof __WEBPACK_EXTERNAL_MODULE_69__ === 'undefined') {var e = new Error("Cannot find module \"undefined\""); e.code = 'MODULE_NOT_FOUND'; throw e;}
module.exports = __WEBPACK_EXTERNAL_MODULE_69__;


//////////////////
// WEBPACK FOOTER
// external {"root":"interact","commonjs":"interactjs","commonjs2":"interactjs","amd":"interact"}
// module id = 69
// module chunks = 0